// extracted by mini-css-extract-plugin
module.exports = {"body":"EOOgFNZ4","skeletonWrapper":"MZCuVq7m","chartAreaWrapper":"Ejho20lH","container":"OIGbJEsy"};